import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-pull-to-refresh',
  templateUrl: './pull-to-refresh.component.html',
  styleUrls: ['./pull-to-refresh.component.scss']
})
export class PullToRefreshComponent {
  @Output() refresh = new EventEmitter<void>();

  pullDistance = 0;
  isPulling = false;
  isRefreshing = false;

  private startY = 0;
  private canPull = false;
  private readonly threshold = 60;

  onTouchStart(event: TouchEvent): void {
    if (this.isRefreshing) return;
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    // Only allow pull if we're at the very top when the touch starts
    this.canPull = scrollTop <= 0;
    this.startY = event.touches[0].clientY;
  }

  onTouchMove(event: TouchEvent): void {
    if (this.isRefreshing || !this.canPull) return;

    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    if (scrollTop > 0) {
      this.reset();
      return;
    }

    const currentY = event.touches[0].clientY;
    const diff = currentY - this.startY;

    if (diff > 0) {
      this.isPulling = true;
      this.pullDistance = Math.min(diff * 0.5, 120);
    }
  }

  onTouchEnd(): void {
    if (this.isRefreshing || !this.canPull) {
      this.reset();
      return;
    }

    if (this.pullDistance >= this.threshold) {
      this.isRefreshing = true;
      this.refresh.emit();
      setTimeout(() => this.reset(), 2000);
    } else {
      this.reset();
    }
  }

  reset(): void {
    this.isPulling = false;
    this.isRefreshing = false;
    this.pullDistance = 0;
    this.canPull = false;
  }
}
